import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { stack } from "@ui/style";
import CongratulationIcon from "@assets/pictures/Congratulation.svg";
import React, { useEffect } from "react";
import { SURVEY_COMPLETION_POSTMESSAGE } from "@domain/user/user-survey";

export const ThankYouSurvey: React.FC = () => {
	const { format } = useI18n();

	useEffect(() => {
		window.parent.postMessage(SURVEY_COMPLETION_POSTMESSAGE, window.location.origin);
	}, []);

	return (
		<Container>
			<CongratulationIcon />
			<h1>{format("survey.popup.thankYou.title")}</h1>
			<p>{format("survey.popup.thankYou.body")}</p>
		</Container>
	);
};

const Container = styled.div`
	background-color: white;
	${stack("L", "flexstart", "center")}
	text-align: center;
	padding: 24px;
	min-height: 100vh;
`;
